<section class="modal-content">
  <section class="header-modal checkout-modal modal-selector modal-with-select">
    <section class="modal-dialog d-flex">
      <section class="modal-content step-3">
        <div class="close">
          <i
            class="fa-solid fa-x c-icon-primary c-icon-primary-sm c-icon-round-hover mr-3 mt-4"
            (click)="modal.dismissAll('Cross click')"></i>
        </div>
        <section class="modal-header cart-Modal-Header">
          <h2 class="c-heading-36 font-bold w-100" id="modal-basic-title">
            {{ 'header.selectChannel' | cxTranslate }}
          </h2>
        </section>
        <section class="modal-body">
          <section>
            <section class="custom-radio radio_grp label-location w-100">
              <table aria-describedby="selectChannel" class="w-100 mt-2">
                <tr class="line-location">
                  <td class="u-border-top-grey pt-1 pb-4">
                    <input
                      type="radio"
                      (change)="selectChannel($event.target.value)"
                      id="channelPrivate"
                      name="channel"
                      value="PRIVATE"
                      class="custom-control-input"
                      [checked]="selectedChannel == 'PRIVATE'" />
                    <label
                      class="custom-control-label secloct w-100 text-fixed-medium font-bold text-capitalize"
                      for="channelPrivate">
                      {{ 'header.private' | cxTranslate }}
                    </label>
                  </td>
                </tr>
                <tr class="line-location">
                  <td class="u-border-top-grey pt-1">
                    <input
                      type="radio"
                      (change)="selectChannel($event.target.value)"
                      id="channelPublic"
                      name="channel"
                      value="PUBLIC"
                      class="custom-control-input"
                      [checked]="selectedChannel == 'PUBLIC'" />
                    <label
                      class="custom-control-label secloct w-100 text-fixed-medium font-bold text-capitalize"
                      for="channelPublic">
                      {{ 'header.public' | cxTranslate }}
                    </label>
                  </td>
                </tr>
              </table>
            </section>
          </section>
        </section>
        <section class="modal-footer justify-content-start">
          <button
            type="button"
            class="c-button c-button--primary ml-3"
            (click)="submit()"
            [disabled]="!selectedChannel">
            {{ 'account.done' | cxTranslate }}
          </button>
        </section>
      </section>
    </section>
  </section>
</section>
